import { apiGetBlob } from './apiClient';

// The same ticker's icon appears in many rows at once — a card grid, the
// search dropdown, the asset view — and search results remount on every
// keystroke. An <img src> let the browser coalesce all of that; fetch() does
// not, so without this each mount is its own request to a proxy that verifies
// a token and reads Firestore per call.
//
// The entry is the cache, so object URLs are deliberately never revoked: the
// icon set is small and immutable (the endpoint serves them with a 30-day
// immutable max-age), and revoking would defeat the reuse this exists for.
const icons = new Map<string, Promise<string>>();

export function assetIconUrl(path: string): Promise<string> {
    let pending = icons.get(path);
    if (!pending) {
        pending = apiGetBlob(path).then(blob => URL.createObjectURL(blob));
        // Do not cache a failure forever: a denied or dropped request should
        // be retryable the next time an icon for it mounts. The caller still
        // sees this rejection — dropping the entry does not swallow it.
        pending.catch(() => icons.delete(path));
        icons.set(path, pending);
    }
    return pending;
}

// Tests only: module-level state would otherwise leak between cases.
export function resetAssetIconCache(): void {
    icons.clear();
}
